import { GetterTree } from 'vuex';
import { State } from './database.store';
import * as types from '@/components/Database/database.types';

const getters: GetterTree<State, State> = {
  getCurrentDatabase: state => {
    return state.currentDatabaseType;
  },
  getCurrentDatabaseService: state => {
    return state.currentDatabaseService;
  },
  getDatabaseServices: state => {
    return state.databaseServices;
  },
 [types.databaseGetters.GET_AVG_CPU]: state => {
    return state.avgCpu;
  },
  [types.databaseGetters.GET_AVG_MEMORY]: state => {
    return state.avgMemory
  }
};

export default getters;
